import { SvgIconColors } from '@cmg/design-system';

import { OrderBookState } from '../../../../../graphql';

export const orderBookStateColors: Record<OrderBookState, SvgIconColors> = {
  [OrderBookState.Open]: 'success',
  [OrderBookState.Closed]: 'error',
  [OrderBookState.NeverOpened]: 'action',
};
